import React from 'react';

export const RequiredIndicator = () => <span className="font-bold text-poppy">*</span>;

export default RequiredIndicator;
